/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout, Card, ProgressBar } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import history from 'src/routes/history';

import * as installActions from 'actions/install-actions';

type Props = WithI18nProps;
// DONE
class Progress extends Component<Props> {
  state = {
    alertedNotify: false
  };
  componentWillReceiveProps(nextProps) {
    const { installStatus, installThemeUpdatedAt } = nextProps;
    const { alertedNotify } = this.state;
    const percent = nextProps.installSyncPercent + nextProps.installSetupThemePercent;

    // Check if the install theme is hanged
    const isHangedInstallTheme = this.checkHangInstallTheme(installStatus, installThemeUpdatedAt);

    // Continue to get status if there is no error or hanging
    if (
      nextProps.loading === false &&
      percent < 100 &&
      nextProps.installStatus !== 'error' &&
      !isHangedInstallTheme
    ) {
      const { getInstallStatus, alertSlowInstallation } = this.props;
      setTimeout(async () => {
        if (!alertedNotify) {
          const installStatusResponse = await getInstallStatus();
          const autoThemeSetupStatus = _.get(
            installStatusResponse,
            'payload.data.autoThemeSetupStatus',
            {}
          );
          const createdAt = parseInt(_.get(autoThemeSetupStatus, 'createdAt', 0));
          const now = new Date().getTime() / 1000;
          const currentDuration = now - createdAt;
          if (
            this.getTimeStayByTotalProduct() > 0 &&
            currentDuration >= this.getTimeStayByTotalProduct()
          ) {
            this.setState({ alertedNotify: true });
            //call api trigger notify
            await alertSlowInstallation({ currentDuration: Math.floor(currentDuration) });
          }
        }
      }, 1000);
    }

    if (nextProps.loading === false && percent >= 100) {
      history.push({
        pathname: routes.setupComplete.view(),
        search: `themeId=${nextProps.installThemeId}&themeName=${encodeURIComponent(
          nextProps.installThemeName
        )}`
      });
    }
  }

  render() {
    const {
      installSyncPercent = 0,
      installSetupThemePercent = 0,
      installStep,
      installTotal,
      installCurrentStep = '',
      i18n
    } = this.props;

    const percent = Math.floor(installSyncPercent + installSetupThemePercent);

    return (
      <Layout.Section>
        <div className="align-center ">
          <Card
            sectioned
            title={i18n.translate('AdminHTML.Installation.TwoDashInitializing.progress_CardTitle', {
              nt1_number: installStep,
              nt2_number: installTotal,
              nt_step_title: installCurrentStep
                ? i18n.translate(installCurrentStep)
                : installCurrentStep
            })}>
            <ProgressBar progress={percent} />
          </Card>
        </div>
      </Layout.Section>
    );
  }

  checkHangInstallTheme = (installStatus, installThemeUpdatedAt) => {
    if (installStatus === 'running' && installThemeUpdatedAt) {
      const dateDiff = Math.floor(Date.now() / 1000) - installThemeUpdatedAt;
      // The install theme is hanged if last updated is bigger than 15 mins
      if (dateDiff > 900) {
        this.props.displayErrorModal();
        return true;
      }
    }

    return false;
  };

  getTimeStayByTotalProduct = () => {
    const { currentTotalProducts } = this.props;
    if (currentTotalProducts >= 1000 && currentTotalProducts < 2000) {
      return 5 * 60;
    }
    if (currentTotalProducts >= 2000 && currentTotalProducts < 5000) {
      return 10 * 60;
    }
    if (currentTotalProducts >= 5000 && currentTotalProducts < 10000) {
      return 20 * 60;
    }
    if (currentTotalProducts > 10000) {
      return 1;
    }
    return -1;
  };
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const currentTotalProducts = _.get(tenantApp, 'appParams.currentTotalProducts', 0);
  return {
    currentTotalProducts,
    loading: state.install.loading,
    installStatus: state.install.installStatus,
    installSyncPercent: state.install.installSyncPercent,
    installSetupThemePercent: state.install.installSetupThemePercent,
    installStep: state.install.installStep,
    installTotal: state.install.installTotal,
    installCurrentStep: state.install.installCurrentStep,
    installThemeId: state.install.installThemeId,
    installThemeName: state.install.installThemeName,
    installThemeUpdatedAt: state.install.installThemeUpdatedAt
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInstallStatus: () => dispatch(installActions.getInstallStatus(ownProps.i18n)),
  alertSlowInstallation: data => dispatch(installActions.alertSlowInstallation(data))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Progress));
